import React, { useState, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import axiosClient from "../../axios-client";

const RegisterWithOTP = ({
  isOpen,
  closeModal,
  onRegisterSuccess,
  planDetails,
  payload,
}) => {
  const location = useLocation();
  const path = location.pathname.split("/").filter(Boolean).pop();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordMatch, setPasswordMatch] = useState(null);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [isCaptchaChecked, setIsCaptchaChecked] = useState(false);
  const [showOtpVerification, setShowOtpVerification] = useState(false);

  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword(!showConfirmPassword);

  const isPasswordValid = (pwd) =>
    pwd.length >= 8 &&
    pwd.length <= 32 &&
    /[A-Za-z]/.test(pwd) &&
    /\d/.test(pwd);

  useEffect(() => {
    if (!password && !confirmPassword) {
      setPasswordMatch(null);
      return;
    }
    if (password && !isPasswordValid(password)) {
      setPasswordMatch(false);
    } else if (password && confirmPassword) {
      setPasswordMatch(password === confirmPassword);
    } else {
      setPasswordMatch(null);
    }
  }, [password, confirmPassword]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      firstName &&
      lastName &&
      mobile &&
      email &&
      password &&
      confirmPassword &&
      acceptTerms &&
      isCaptchaChecked
    ) {
      if (!isPasswordValid(password)) {
        alert(
          "Password must be 8-32 characters long and contain both letters and numbers."
        );
        return;
      }
      if (password !== confirmPassword) {
        alert("Passwords do not match.");
        return;
      }
      const name = `${firstName} ${lastName}`.trim();
      try {
        const response = await axiosClient.post("/users/register", {
          name,
          email,
          password,
          mobile,
          plan: planDetails?.planId,
        });
        console.log(response, "success");
        if (response.status === 201) {
          alert(response.data?.message || "User registered successfully!");
          onRegisterSuccess(); // Trigger login modal open
        } else {
          alert("Registration failed. Please try again.");
        }
      } catch (error) {
        console.error("Registration error:", error);
        const errorMsg =
          error?.response?.data?.message ||
          error?.message ||
          "Registration error. Please check your input and try again.";
        alert(errorMsg);
      }
    } else {
      alert("Please fill in all required fields and accept the terms");
    }
  };

  const handleOtpSubmit = () => {
    // Handle OTP verification logic here
    closeModal();
  };

  if (!isOpen) return null;

  const handlePrivacyPolicyClick = () => {
    window.open("/privacy-policy");
  };

  const handleTermsOfServiceTermsClick = () => {
    window.open("/Term-of-Use");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 font-inter">
      <div className="bg-white rounded-xl shadow-lg p-8 w-11/12 max-w-md md:max-w-4xl relative">
        <button
          onClick={closeModal}
          className="absolute top-1 right-3 text-gray-600 hover:text-gray-900 text-2xl"
        >
          &times;
        </button>
        {!showOtpVerification ? (
          <div className="grid md:grid-cols-2 rounded-lg">
            <div className="w-[90%]">
              <img
                src="images/login.png"
                alt="Login"
                className="w-[90%] h-auto max-w-[275px] block mx-auto"
              />
              <ul className="font-inter text-sm w-full ml-4">
                <li className="flex items-center gap-4 mb-4">
                  <img
                    src="images/check_circle.png"
                    alt="dff"
                    className="w-5 h-5"
                  />
                  Comprehensive Report Search with Advanced Filter
                </li>
                <li className="flex gap-4 items-center mb-4">
                  <img
                    src="images/check_circle.png"
                    alt="dff"
                    className="w-5 h-5"
                  />
                  Interactive Data Visualizations
                </li>
                <li className="flex gap-4 items-center mb-4">
                  <img
                    src="images/check_circle.png"
                    alt="dff"
                    className="w-5 h-5"
                  />
                  Dynamic Insights Access
                </li>
                <li className="flex gap-4 items-center mb-4">
                  <img
                    src="images/check_circle.png"
                    alt="dff"
                    className="w-5 h-5"
                  />
                  Real-Time Alerts for New Reports
                </li>
                <li className="flex gap-4 items-center mb-4">
                  <img
                    src="images/check_circle.png"
                    alt="dff"
                    className="w-5 h-5"
                  />
                  Robust Community Support
                </li>
              </ul>
              <div className="flex items-center justify-center mb-2">
                <img
                  src="/images/Bizwitlogo.svg"
                  alt="Nav Brand"
                  className="w-[50%]"
                />
              </div>
            </div>
            <form
              // onSubmit={handleSubmit}
              className="space-y-5 bg-lightPink p-5 rounded-xl shadow"
            >
              <div className="flex space-x-4">
                <div className="w-1/2 mt-0">
                  <label className="block text-sm font-medium mb-1">
                    First Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={firstName}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only alphabetic characters (a-z, A-Z) using regex
                      if (/^[a-zA-Z]*$/.test(value)) {
                        setFirstName(value);
                      }
                    }}
                    className="w-full px-4 py-2 rounded-md focus:ring-2 focus:ring-blue-400"
                    placeholder="Type Here"
                    required
                  />
                </div>
                <div className="w-1/2  mt-0">
                  <label className="block text-sm font-medium mb-1">
                    Last Name <span className="text-red-500"></span>
                  </label>
                  <input
                    type="text"
                    value={lastName}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only alphabetic characters (a-z, A-Z) using regex
                      if (/^[a-zA-Z]*$/.test(value)) {
                        setLastName(value);
                      }
                    }}
                    className="w-full px-4 py-2 rounded-md focus:ring-2 focus:ring-blue-400"
                    placeholder="Type Here"
                  />
                </div>
              </div>
              <div className="mt-2">
                <label className="block text-sm font-medium mb-1 ">
                  Mobile No. <span className="text-red-500">*</span>
                </label>
                <input
                  type="text" // Use text to prevent issues with type="number" allowing invalid inputs like `e` or `+`.
                  value={mobile}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only numbers and restrict the length to 10 digits
                    if (/^\d{0,10}$/.test(value)) {
                      setMobile(value);
                    }
                  }}
                  className="w-full px-4 py-2 rounded-md focus:ring-2 focus:ring-blue-400"
                  placeholder="Enter your Mobile Number"
                  required
                />
              </div>
              <div className="mt-2">
                <label className="block text-sm font-medium mb-1">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-2 rounded-md focus:ring-2 focus:ring-blue-400"
                  placeholder="Enter your email address"
                  required
                />
              </div>

              <div className="flex space-x-4 mt-0">
                <div className="w-1/2 mt-0">
                  <div className="relative mt-2">
                    <label className="block text-sm font-medium mb-1">
                      Password <span className="text-red-500">*</span>
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="w-full px-4 py-2 rounded-md focus:ring-2 focus:ring-blue-400 pr-10"
                      placeholder="Create a strong password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 mt-6"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? (
                        <FaEye className="h-5 w-5 text-[#1c1b1f]" />
                      ) : (
                        <FaEyeSlash className="h-5 w-5 text-[#1c1b1f]" />
                      )}
                    </button>
                  </div>
                </div>
                <div className="w-1/2  mt-0">
                  <div className="relative mt-2">
                    <label className="block text-sm font-medium mb-1">
                      Confirm Password <span className="text-red-500">*</span>
                    </label>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className="w-full px-4 py-2 rounded-md focus:ring-2 focus:ring-blue-400 pr-10"
                      placeholder="Re-enter your password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 mt-6"
                      onClick={toggleConfirmPasswordVisibility}
                    >
                      {showConfirmPassword ? (
                        <FaEye className="h-5 w-5 text-[#1c1b1f]" />
                      ) : (
                        <FaEyeSlash className="h-5 w-5 text-[#1c1b1f]" />
                      )}
                    </button>
                  </div>
                </div>
              </div>
              {passwordMatch !== null && (
                <div
                  className={`text-sm ${
                    passwordMatch ? "text-green-500" : "text-red-500"
                  } mt-2`}
                >
                  {passwordMatch
                    ? "Passwords match and are valid!"
                    : !isPasswordValid(password)
                    ? "Password must be at least 8 characters long and contain both letters and numbers."
                    : "Passwords do not match!"}
                </div>
              )}
              <div className="flex items-center justify-between bg-white px-4 py-3 rounded-md">
                <div className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    id="captcha"
                    className="w-4 h-4"
                    checked={isCaptchaChecked}
                    onChange={(e) => setIsCaptchaChecked(e.target.checked)}
                    required
                  />
                  <label htmlFor="captcha" className="text-sm ">
                    I'm not a robot
                  </label>
                </div>
                <img
                  src="images/captcha.png"
                  alt="Captcha"
                  className="w-10 h-8"
                />
              </div>
              <button
                // type="submit"
                onClick={handleSubmit}
                className="w-full bg-black text-white py-3 rounded-md"
              >
                Register Now
              </button>
              {payload !== undefined && (
                <p className="text-center text-sm text-[#848484] font-medium">
                  Already have an account?
                  <div
                    onClick={() => payload()}
                    className="text-black underline hover:text-[#3c3c3c]"
                  >
                    Login Now
                  </div>
                </p>
              )}
              <div className="flex items-center space-x-2 font-inter font-medium">
                <input
                  type="checkbox"
                  id="acceptTerms"
                  className="w-4 h-4 text-blue-600"
                  checked={acceptTerms}
                  onChange={(e) => setAcceptTerms(e.target.checked)}
                  required
                />
                <label htmlFor="acceptTerms" className="text-sm">
                  I accept the{" "}
                  <Link
                    onClick={handlePrivacyPolicyClick}
                    // to="/privacy-policy"
                    className="text-blue-600 underline"
                  >
                    Privacy Policy
                  </Link>{" "}
                  and{" "}
                  <Link
                    onClick={handleTermsOfServiceTermsClick}
                    to="/Term-of-Use"
                    className="text-blue-600 underline"
                  >
                    Terms of Service
                  </Link>
                  .
                </label>
              </div>
            </form>
          </div>
        ) : (
          <div className="text-center font-inter w-full">
            <h2 className="text-2xl sm:text-3xl font-medium mb-4">
              Get access to your account
            </h2>
            <p className="font-medium mb-6 text-sm sm:text-base">
              Please enter the code that we have sent to your email address,
              <br className="hidden sm:inline" />
              <span className="font-bold">{email}</span>
            </p>

            <div className="flex justify-center space-x-2 sm:space-x-4 mb-6">
              {[1, 2, 3, 4, 5].map((_, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength="1"
                  className="w-10 h-10 sm:w-14 sm:h-14 text-center rounded-lg border5 focus:outline-none focus:ring-2 focus:ring-black bg-lightPink font-medium text-xl"
                />
              ))}
            </div>

            <p className="text-xs sm:text-sm mb-6">
              Didn't receive your code?{" "}
              <button className="text-[#1ba4d2] hover:text-blue-600 underline">
                Resend Code
              </button>
            </p>

            <button
              onClick={handleOtpSubmit}
              className="bg-black text-white py-2 px-4 sm:py-3 sm:px-20 font-medium rounded-md text-sm sm:text-base w-full sm:w-auto"
            >
              Continue with verification code
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RegisterWithOTP;
